import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const AppsFlyerIntegrationCreationSchema = z.object({
  name: z.string(),
  iosId: z.string(),
  androidId: z.string(),
  apiToken: z.string().nullable(),
});
export const AppsFlyerIntegrationSchema = z
  .object({
    id: z.string(),
    isActive: z.boolean().optional(),
  })
  .extend(AppsFlyerIntegrationCreationSchema.shape);

export const AppsFlyerResponseSchema = createResponseSchema(
  AppsFlyerIntegrationSchema,
);
